import { Flex } from '@components';
import { styled } from '@mui/material';

export const StyledContainer = styled(Flex)(({ theme }) => ({
  padding: theme.spacing(11, 17),
  backgroundColor: theme.palette.grey[100],
  gap: theme.spacing(6),
  position: 'fixed',
  bottom: 0,
  zIndex: 1000,
  flex: 1,
  width: '100%',
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(8, 16),
  },
}));
